import React from 'react';
import keyBy from 'lodash/keyBy';
import { WarningTwoTone } from '@ant-design/icons';
import LanguageFlag from '@guuru/react-language-flag';
import { COLORS } from '@guuru/theme-common';
import { AvatarGroup } from './style';

interface LanguagesProps {
  locales?: string[] | Record<string, string>;
  maxCount?: number;
}

const Languages = function ({
  locales = {},
  maxCount = undefined,
}: LanguagesProps) {
  const langs = Array.isArray(locales) ? keyBy(locales) : locales;
  if (Object.keys(langs).length === 0) {
    return (
      <WarningTwoTone twoToneColor={COLORS.yellow} />
    );
  }

  return (
    <AvatarGroup
      max={{
        count: maxCount,
        style: {
          color: 'rgba(0, 0, 0, 0.45)',
          backgroundColor: 'transparent',
          lineHeight: '25px',
          height: '25px',
        },
        popover: {
          placement: 'topRight',
        },
      }}
    >
      {Object.keys(langs).map((language) => (
        langs[language as keyof typeof langs] && (
          <LanguageFlag
            style={{ paddingRight: 4, whiteSpace: 'nowrap' }}
            key={`expert_language_${language}`}
            languageCode={language}
          />
        )))}
    </AvatarGroup>
  );
};

export default Languages;
